import Offcanvas from 'bootstrap/js/dist/offcanvas';
export function initNavigation() {
    burgerMenu()
    dropdownMenu();
    runStickyNav();
}

function burgerMenu(){
    const navbarOffcanvasElm = document.getElementById('offcanvasNavbar')
    const bsOffcanvas = new Offcanvas('#offcanvasNavbar')
    let isClosed = false;
    let burgerMenu = document.querySelector("#hamburger")
    let btnToggler=document.querySelector('.navbar__toggler');


    btnToggler.addEventListener('click', (event)=>{  
        event.preventDefault();
        if (isClosed== true) {
            burgerMenu.classList.remove("open");
            burgerMenu.classList.add("closed");
            isClosed  = false;
            bsOffcanvas.hide();
        } else {
            burgerMenu.classList.remove("closed");
            burgerMenu.classList.add("open");
            isClosed = true;
            bsOffcanvas.show();
        }
    });

    navbarOffcanvasElm.addEventListener('hidden.bs.offcanvas', event => {
        burgerMenu.classList.remove("open");
        burgerMenu.classList.add("closed");
        isClosed  = false;
    })
}
function dropdownMenu() { 
    // Get all menu items with the class navbar-custom__menu-item
    const menuItemHasChildren=document.querySelectorAll('.menu-item-has-children');
    const menuLinks = document.querySelectorAll('.menu-item-has-children > .navbar__menu-link');
    const submenuLinks = document.querySelectorAll('.sub-menu  .navbar__menu-link');
    // // Add an event listener to each menu item
    const svgIcon = `<svg class="navbar__menu-icon one"  width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5463_7126)">
<path d="M10.75 16.75L17 10.5M17 10.5L10.75 4.25M17 10.5H2" stroke="#A3A3A3" stroke-width="1.5" stroke-linecap="square"/>
</g>
<defs>
<clipPath>
<rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20.5 0.5)"/>
</clipPath>
</defs>
</svg>

<svg class="navbar__menu-icon two"  width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5463_7126)">
<path d="M10.75 16.75L17 10.5M17 10.5L10.75 4.25M17 10.5H2" stroke="#A3A3A3" stroke-width="1.5" stroke-linecap="square"/>
</g>
<defs>
<clipPath>
<rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20.5 0.5)"/>
</clipPath>
</defs>
</svg>`;
    submenuLinks.forEach((menuLink) => {
        const span = document.createElement("span");
        span.innerHTML = svgIcon;

        // Insert the SVG before the link text
        menuLink.append(span);
    });
    

    if(window.innerWidth <= 1200){
        // Select all elements with the class 'sub-menu'
        const subMenus = document.querySelectorAll('.sub-menu');
        // Loop through each .sub-menu element
        subMenus.forEach(subMenu => {
            // Create a new <li> element
            const newListItem = document.createElement('li');
            // Add classes to the <li> element
            newListItem.classList.add('back-to-root', 'navbar__menu-item');
            
            // Create a new <a> element
            const newLink = document.createElement('a');
            // Set the href and class for the <a> element
            newLink.href = "#";
            newLink.classList.add('navbar__list-menu');

            const svg = document.createElement('span');
            svg.innerHTML = `
                <svg width="19" height="9" viewBox="0 0 19 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.646446 4.14645C0.451185 4.34171 0.451185 4.65829 0.646446 4.85355L3.82843 8.03553C4.02369 8.2308 4.34027 8.2308 4.53553 8.03553C4.7308 7.84027 4.7308 7.52369 4.53553 7.32843L1.70711 4.5L4.53553 1.67157C4.7308 1.47631 4.7308 1.15973 4.53553 0.964466C4.34027 0.769204 4.02369 0.769204 3.82843 0.964466L0.646446 4.14645ZM19 4L1 4V5L19 5V4Z" fill="black"/>
                </svg> List Menu
            `;
            newLink.appendChild(svg);
            
            // Append the <a> element to the <li> element
            newListItem.appendChild(newLink);
            
            // Append the new <li> to the current <ul>
            subMenu.appendChild(newListItem);
        });

        menuLinks.forEach((menuLink) => {
            menuLink.addEventListener('click', (e) => {
                e.preventDefault();
                const parentItem = menuLink.parentElement;
                const parentItemActive=parentItem.classList.contains('active');
                // Check if the clicked card is already active
                const isActive = menuLink.classList.contains('active');
    
                parentItem.classList.toggle('active');
                // Remove the active class from all menu items
                menuItemHasChildren.forEach((item) => item.classList.remove('active'));
                menuLinks.forEach((item) => item.classList.remove('active'));
                 // Add 'active' class to the clicked card only if it was not active
                
                if(!parentItemActive){
                    parentItem.classList.add('active');
                }
                if (!isActive) {
                    menuLink.classList.add('active');
                }
            });
        });
    }



    document.querySelectorAll('.navbar__list-menu').forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            // Find all elements with the class 'active'
            let navbarCustomMenuItem=document.querySelectorAll('.navbar__menu-item.active');
            let navbarCustomMenuLink=document.querySelectorAll('.navbar__menu-link.active');
            // Remove the 'active' class from each element
            navbarCustomMenuItem.forEach(item => item.classList.remove('active'));
            navbarCustomMenuLink.forEach(link => link.classList.remove('active'));
        });
    });
}

function runStickyNav() {
    window.addEventListener('scroll', stickyNav);
}

function stickyNav(){
    const navHeader = document.querySelector('.navbar-custom');
    const floatingButton=document.querySelector('.floating-button');
    let scrollY=window.scrollY;
    let currentScrollPos = window.scrollY;
    setTimeout(function(){
        if(scrollY<=0){
            navHeader.classList.remove('show');
        } else if(scrollY > 200){
            navHeader.classList.add('show');
            floatingButton.classList.add('show');
        } else {
            navHeader.classList.remove('show');
            floatingButton.classList.remove('show');
        }
    }, 100);
}


